import * as React from 'react';

import StatusLabel from 'components/status-label/StatusLabel';

import { SUBCAMPAIGN_STATE_TO_LABEL_TYPE, isRevoked } from 'utils/subcampaign';
import { __t, applyTranslations } from 'utils/language';

import type { InfluencerCampaignHistoryItem } from 'types';

applyTranslations(require('./campaign-history-offer-state.i18n.json'));

type Props = {
  item: InfluencerCampaignHistoryItem
};

const CampaignHistoryOfferState = (
  {
    item
  }: Props
): JSX.Element => {
  if (isRevoked(item.subcampaign)) {
    return (
      <StatusLabel
        size="tiny"
        label={__t(`campaign_history_offer_state.label_revoked_by_${String(item.subcampaign.revokedBy)}`)}
        type={SUBCAMPAIGN_STATE_TO_LABEL_TYPE.revoked}
      />
    );
  }

  if (item.offer.state === 'draft') {
    return (
      <StatusLabel
        size="tiny"
        label={__t('campaign_history_offer_state.label_draft')}
        type="info"
      />
    );
  }

  return (
    <StatusLabel
      size="tiny"
      label={__t(`campaign_history_offer_state.label_${String(item.offer.state)}`)}
      type={SUBCAMPAIGN_STATE_TO_LABEL_TYPE[String(item.offer.state)]}
    />
  );
};

export default CampaignHistoryOfferState;
